import { SMELTER_REACH } from '../data/fusion.js';
import { getItem, RARITIES } from '../data/items.js';
/**
 * Fusion at the smelter (ADR 0018), pure: which piece five identical ones
 * make, and what it costs. The server applies it, the client previews it.
 */
/**
 * The piece five of these make: the same piece, one rarity up. A set piece
 * of the biome sets has its four rarities under one base id (`wooden-sword`,
 * `wooden-sword-rare`…); anything else, and a legendary, fuses into nothing.
 */
export function fusionResult(template) {
    if (template.kind !== 'equipment' || template.cosmetic)
        return undefined;
    const rank = RARITIES.indexOf(template.rarity);
    const next = RARITIES[rank + 1];
    if (next === undefined)
        return undefined;
    const base = template.id.replace(/-(rare|epic|legendary)$/, '');
    if (rank > 0 && base === template.id)
        return undefined;
    const result = getItem(`${base}-${next}`);
    if (result === undefined || result.slot !== template.slot || result.rarity !== next) {
        return undefined;
    }
    return result;
}
/** Gold the smelter asks: what the merchant would pay for the piece made, one coin at least. */
export function fusionCost(template) {
    const result = fusionResult(template);
    return result === undefined ? undefined : Math.max(1, result.sellPrice);
}
/** Within `SMELTER_REACH` tiles of one of these smelters, diagonals included. */
export function withinSmelterReach(at, smelters) {
    return smelters.some((smelter) => Math.max(Math.abs(smelter.x - at.x), Math.abs(smelter.y - at.y)) <= SMELTER_REACH);
}
//# sourceMappingURL=fusion.js.map